import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link, useNavigate } from 'react-router-dom'
import AuthService from '../../services/auth.service'
import { pathname } from '../../utils/constants/pathname'
import { validators } from '../../utils/helpers/validators'
import logo from '../../assets/imgs/logos/logo.svg'
import Button from '../../components/common/buttons'
import InputTextComp from '../../components/common/form-components/inputs/InputTextComp'
import './recover-password.scss'

const RecoverPassword = () => {
  const { formatMessage: msg } = useIntl()
  const navigate = useNavigate()

  const [email, setEmail] = useState('')

  const handleChange = (event) => {
    const value = event.target.value
    setEmail(value)
  }

  const handleSubmit = async () => {
    const resp = await AuthService.recoverPassword({ email })
    if (resp) {
      navigate(pathname.LANDING)
    }
  }

  const validate = validators.emailFormat(email)

  return (
    <div className="recover-password">
      <div className="recover-box">
        <div className="form-recover">
          <Link to={pathname.LOGIN}>
            <img className="logo-box" src={logo} alt="logo-moure" />
          </Link>

          <div className="box-form">
            <p className="title-form">
              <FormattedMessage id="password.recover" />
            </p>

            <InputTextComp
              name="email"
              value={email}
              onChange={(e) => handleChange(e)}
              placeholder={msg({ id: 'email' })}
            />

            <Button
              id="submitReset"
              btnText={<FormattedMessage id="button.send" />}
              btnType="button"
              btnClass="btn__with-bg-type-2"
              isDisabled={!validate}
              onHandleClick={() => handleSubmit()}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RecoverPassword
